import { LinkCardContainerComponent } from "./link-card-container/link-card-container.component";
import { IconModule } from "./../icon/icon.module";
import { CardModule } from "./../card/card.module";
import { NgModule } from "@angular/core";
import { LinkCardComponent } from "./link-card.component";
import { CommonModule } from "@angular/common";

@NgModule({
	declarations: [LinkCardComponent, LinkCardContainerComponent],
	imports: [CommonModule, CardModule, IconModule],
	exports: [LinkCardComponent, LinkCardContainerComponent]
})
export class LinkCardModule {}
